import { InfoOutlined } from '@mui/icons-material';
import { Tooltip, type TooltipProps } from '@mui/material';
import type { ReactElement } from 'react';

type InputTooltipProps = Omit<TooltipProps, 'title' | 'children'> & {
  tip: string;
};

/**
 * Slabstack custom tooltip that utilizes MUI. Its primary purpose is to
 * wrap our Input-like components that have error message padding such that
 * the tip is displayed closer to the Input TextField.
 */
export const InputTooltip = ({ tip, ...props }: InputTooltipProps): ReactElement => {
  return (
    <Tooltip title={tip} {...props}>
      <InfoOutlined
        sx={{
          fontSize: 16,
        }}
      />
    </Tooltip>
  );
};
